import React, {
  useRef,
  useContext,
  useEffect,
  useState,
  RefObject,
  CSSProperties
} from 'react';
import './CustomTab.scss';
import classNames from 'classnames';
import { ThemeContext } from '../../store/ThemeProvider';
import SwipeableViews from 'react-swipeable-views';
import RenderComponent, {
  RenderComponentWithWrapper
} from '../Gallery/RenderComponent';
import { IComponent, IComponentSlideHead, IComponentXHead } from '../../component';
import {PageContext} from '../ComponentNavigatorV2/PageContext';
import GalleryListWrapper from '../GalleryList/GalleryListWrapper';
import uGalleryListWrapper from '../GalleryHome/useGalleryListWrapper';
import { createPortal } from 'react-dom';
import useScrollFixElement from '../hooks/useScrollFixElement';
import usePortalDom from '../hooks/usePortalDom';
import { getPageSameType } from '../../utils/util';
import { resolveLocaleText } from '../../utils/localeText';
import type { ILocaleTextMap } from '../../types/localeText';

export interface ICustomOneTab {
  title: string;
  title_i18n?: ILocaleTextMap;
  children: IComponent[];
}
interface ITabClick {
  onClick: (index: number) => void;
}

interface ICustomTabUserCustomer {
  activeColor?: string; // 目前只有left 才会有这个值
  fontSize?: number; //字体大小（目前只允许top去调整）
  isBold?: boolean; //是否加粗 目前也只针对top
}

export interface ICustomTab extends ITabClick, ICustomTabUserCustomer {
  tabs: ICustomOneTab[];
  fixed?: boolean;
  activeIndex: number;
  mode: string;
  cid?: string;
}

interface IOneTab extends ITabClick, ICustomTabUserCustomer {
  name: string;
  active: boolean;
  onClick: () => void;
  mainColor: string;
  h1Color: string;
}
export const OneTab = (props: IOneTab) => {
  const cns = classNames('one-tab', {
    active: props.active
  });
  const tabStyle: CSSProperties = !!props.active
    ? {
        color: props.mainColor,
        backgroundColor: props.activeColor
      }
    : {
        color: props.h1Color
      };

  const tabNameStyle: CSSProperties = {};
  const { isBold, fontSize } = props;
  fontSize && (tabNameStyle.fontSize = fontSize);
  tabNameStyle.fontWeight = isBold ? 'bold' : 'normal';

  return (
    <div className={cns} onClick={props.onClick} style={tabStyle}>
      <div className="tab-name" style={tabNameStyle}>
        {props.name}
      </div>
      <div
        className="bottom-line"
        style={{ background: !!props.active ? props.mainColor : 'transparent' }}
      />
    </div>
  );
};
const CustomTab = function(props: ICustomTab, context: any) {
  const {
    tabs,
    activeIndex = 0,
    fixed = false,
    mode = 'top',
    activeColor,
    fontSize,
    isBold,
    cid = ''
  } = props;
  const tabRef = useRef<HTMLDivElement>(null);

  // todo: 是否需要固定
  const needToFix = fixed;

  const { isFixed, setWrapper } = useScrollFixElement({
    disable: !needToFix
  });

  useEffect(()=>{
    if(tabRef && tabRef.current) {
      setWrapper(tabRef);
    }
  }, [tabRef]);

  const { h1Color, mainColor, backgroundColor } = useContext(ThemeContext);
  const [activeStatus, setActiveStatus] = useState(
    {} as {
      [key: string]: boolean;
    }
  );

  useEffect(() => {
    setActiveStatus({
      ...activeStatus,
      [`${activeIndex}`]: true
    });
  }, [activeIndex]);

  const renderNormalTabTitle = function(opacity?:boolean) {
    return (
      <div className="tabs">
        {(tabs || []).map((tab, index) => (
          <OneTab
            key={index}
            name={resolveLocaleText(tab.title, tab.title_i18n)}
            active={activeIndex === index}
            activeColor={activeColor}
            fontSize={fontSize}
            isBold={isBold}
            onClick={() => {
              props.onClick(index);
            }}
            mainColor={mainColor}
            h1Color={h1Color}
          />
        ))}
      </div>
    );
  };

  const pageContext = useContext(PageContext);

  const tabWrapper = usePortalDom({
    targetClassName:"fixed-top-wrapper",
    parentElement:window.document.getElementById(`page-top-${pageContext.cid}`)! as HTMLDivElement
  });

  const renderPortalTabTitle = function() {
    return tabWrapper ? createPortal(
      <div className="tab-portal" style={{ backgroundColor }}>
        {renderNormalTabTitle()}
      </div>,
      tabWrapper
    ) : null;
  };

  const [isHome, setIsHome] = useState(true);

  const renderTabTitle = function() {
    return <>
      {renderNormalTabTitle(isFixed)}
      {isFixed ? renderPortalTabTitle() : null}
    </>
  };

  const cls = classNames(`custom-tab`, {
    more: (tabs || []).length > 3 && mode != 'left',
    ['tableft']: mode == 'left',
    ['tabtop']: mode == 'top'
  });

  const isHeaderShowInfo = (comps: any[]): boolean => {
    if(comps && comps.length) {
      const comp = comps[0] as IComponentXHead;
      if(comp && comp.total) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className={cls} ref={tabRef}>
      {renderTabTitle()}
      {(tabs || []).map((tab, index) => {
        const renderTab = (
          <div key={index}>
            {tab.children.map((child, childIndex) => {
              child.forceBg = activeColor;
              return (
                <RenderComponentWithWrapper key={childIndex} {...child} visible={index === activeIndex} />
              );
            })}
          </div>
        );
        // 如果当前tab里含有commentlist的话，则还是需要强制渲染的
        const styles = index == activeIndex ? {} : { display: 'none' };

        let forceRenderComponent = [] as any[];
        let headerComponent = [] as any[];
        getPageSameType(tab.children, forceRenderComponent, ['commentlist', 'gallery']);
        getPageSameType(tab.children, headerComponent, ['slidehead']);
        
        const forceRender = forceRenderComponent && forceRenderComponent.length && isHeaderShowInfo(headerComponent);

        return (
          <div
            className="custom-tab-panel"
            key={index}
            style={styles}
            data-tab-cid={cid}
            data-tab-index={index}
          >
            {activeStatus[`${index}`] || forceRender ? renderTab : null}
          </div>
        );
      })}
    </div>
  );
};

export default CustomTab;
